export default "__VITE_ASSET__DiWb344d__"